import { SET_TABLE_DETAILS, SET_TABLE_VIEW_TYPE} from './TableConstants';

export const setTableDetails = (payload) => async (dispatch) => {
	dispatch({ type: SET_TABLE_DETAILS , payload });
};
export const setTableViewType = (payload) => async (dispatch) => {
	dispatch({ type: SET_TABLE_VIEW_TYPE , payload });
};

